import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import {
  ActivityLinkedToQuestionnaireModule,
  EnumToArrayPipeModule,
  ExternalUrlPipeModule,
  GetCanBeInFormulaPipeModule,
  GetCanDeleteQuestionPipeModule,
  GetLabelRangeFromValuePipeModule,
  GetObsComponentPipeModule,
  GetQuestionNumberPipeModule,
  GetQuestionOptionsPipeModule,
  GetRangePipeModule,
  GetTranslationPipeModule,
  GetValueSetValuePipeModule,
  IsAuthorizedPipeModule,
  IsGoodAnswerPipeModule,
  IsGoodAnswerVer2PipeModule,
  IsObsCompEnabledPipeModule,
  RangeSmileyPipeModule,
  SafeDatePipeModule,
  SplitPipeModule,
} from "@comunicare/comunicare-pipes";
import { GetGenderDisplayPipe } from "../components/ans-practitionner-result/ans-practitionner-result.component";
import { IsActivityADrugPipe } from "../components/careplan/careplan.component";
import { FirstnamesToArrayPipe } from "../components/forms/add-patient/firstnames-to-array.pipe";
import { MapChartColorsPipe } from "../components/observation-chart/map-chart-colors.pipe";
import { IsQuestionEnabledPipe } from "../components/patient-QR/answer-new-qr/answer-new-qr.component";
import { IsNotCompletedPipe } from "../components/patient-QR/answer-new-qr/encode-question/encode-question.component";
import { CanUpdatePipe, FindPreviousQRPipe, QRDatePipe, QRNamePipe } from "../components/patient-QR/patient-QR.component";
import {
  QuestionAnswerCodePipe,
  QuestionAnswerStrPipe,
  ValueSetChoicePipe,
  ValueSetChoicesPipe,
} from "../components/patient-QR/qr-details/qr-details.component";
import { GetResultsPractitionnerPipe, HasResultsPractitionnerMediaPipe } from "../components/patient-alerts/patient-alerts.component";
import {
  FrequencyLabelPipe,
  HasDrugInfoLinkPipe,
  HasDrugKnowledgePipe,
  HasIntakesDataPipe,
  IntakesGaugePipe,
  IntakesToolTipPipe,
} from "../components/patient-drugs/patient-drugs.component";
import {
  DisplayNoSmsCheckbox,
  getIdentityVerificationMethodDisplay,
  GetPractitionerNamePipe,
} from "../components/patient-form/patient-form.component";
import { GetCurrentObservationPipe } from "../components/patient-observations/moment-observation-table/moment-observation-table.component";
import { GetDevicePricePipe } from "../components/prescription-form/prescription-devices-form/prescription-devices-form.component";
import { ValueObservationPipe } from "../models/observations.model";
import { ComputeScoringPipe } from "../models/questionnaireScoring.model";
import { FindGroupAccessPipe } from "../pages/access-groups-page/practitioner-access-groups/practitioner-access-groups.component";
import { GetDataSource, IsBasedOnCareplanPipe } from "../pages/communications-page/communications-page.component";
import { ValidDate } from "../pages/user-list-page/user-list-page.component";
import { ActivityDate } from "./activity-date.pipe";
import { AlertLevelClassPipe } from "./alert-level-class.pipe";
import { DateArrayPipe, ToDatePipe } from "./dates.pipe";
import { DisabledReasonKeyPipe } from "./disabled-reason-key.pipe";
import { DisplayQuantityPipe, DisplayTextForQuantityPipe } from "./drug-quantity.pipe";
import { DisabledFeaturesFeaturesPipe } from "./features.pipe";
import { FilterByKeyValuePipe } from "./filter-by-key-value.pipe";
import { FilterObsDefinitionsPipe } from "./filter-obs-definitions.pipe";
import { FilterObservationsByLoincPipe } from "./filter-observations-by-loinc.pipe";
import { FindIdentifierBySystemPipe } from "./find-identifier-by-system.pipe";
import { FindObsDefByLoincPipe } from "./find-obs-def-by-loinc.pipe";
import { FindObsDefComponentsByLoincPipe } from "./find-obs-def-components-by-loinc.pipe";
import { FirstImagePipe } from "./first-image.pipe";
import { GetEffectiveTimingPipe } from "./get-effective-timing.pipe";
import { GetObsValuesByHoursPipe } from "./get-obs-values-by-hours.pipe";
import { GetPatientFullNamePipe } from "./get-patient-full-name.pipe";
import { GetShortnamePipe } from "./get-shortname.pipe";
import { GetLatestIdentityFromPatientPipe } from "./getLatestIdentityFromPatient.pipe";
import { IdentifierPipe } from "./identifier.pipe";
import { isMomentStringPipe } from "./is-moment-string.pipe";
import { IsDefinedPipe } from "./isDefined.pipe";
import { IsNotDefinedPipe } from "./isNotDefined.pipe";
import { JoinPipe } from "./join.pipe";
import { LogPipe } from "./log.pipe";
import { LoincAndValueMeaningPipe } from "./loinc-to-itranslation.pipe";
import { TranslateObservationNameFromObsDefPipe } from "./observation.pipe";
import { GetOrgNameFromServiceRefPipe, OrgNameFromServiceRefAndMonitLinksPipe } from "./orgNameFromServiceRef.pipe";
import { PositionStylePipe } from "./position-style.pipe";
import { RaHasPdfPipe } from "./ra-has-pdf.pipe";
import { RiskGaugePipe } from "./risk-gauge.pipe";
import { TranslateAlertNamePipe } from "./sharedAlerts.pipe";
import { GetClassesForStepwisePipe, GetStepwisePipe, IsLastOrFirstCellOfStepwisePipe, IsStepwiseSelectedPipe } from "./stepwise-drug.pipe";
import { TeleconsultationLastConnectionPipe } from "./teleconsultation-lastConnection.pipe";
import { TimingDisplay } from "./timing-display.pipe";
import { TruncateListPipe } from "./truncate-list.pipe";
import { TruncatePipe } from "./truncate.pipe";
import { TypeOfPipe } from "./typeof.pipe";
import { IncludesPipe } from "./includes.pipe";
import { VitalSignRangePipe } from "./vital-sign-range.pipe";

@NgModule({
  declarations: [
    IsActivityADrugPipe,
    CanUpdatePipe,
    DisplayQuantityPipe,
    ComputeScoringPipe,
    FindPreviousQRPipe,
    LoincAndValueMeaningPipe,
    ValueObservationPipe,
    QuestionAnswerStrPipe,
    ValueSetChoicesPipe,
    ValueSetChoicePipe,
    QuestionAnswerCodePipe,
    IsQuestionEnabledPipe,
    TranslateAlertNamePipe,
    QRNamePipe,
    QRDatePipe,
    GetEffectiveTimingPipe,
    ActivityDate,
    FirstImagePipe,
    ValidDate,
    IsBasedOnCareplanPipe,
    GetDataSource,
    RaHasPdfPipe,
    TranslateObservationNameFromObsDefPipe,
    OrgNameFromServiceRefAndMonitLinksPipe,
    JoinPipe,
    GetCurrentObservationPipe,
    IntakesGaugePipe,
    HasIntakesDataPipe,
    IntakesToolTipPipe,
    FrequencyLabelPipe,
    TypeOfPipe,
    FindGroupAccessPipe,
    RiskGaugePipe,
    GetGenderDisplayPipe,
    getIdentityVerificationMethodDisplay,
    GetLatestIdentityFromPatientPipe,
    GetPatientFullNamePipe,
    FilterObsDefinitionsPipe,
    FilterObservationsByLoincPipe,
    GetObsValuesByHoursPipe,
    GetShortnamePipe,
    FindObsDefComponentsByLoincPipe,
    LogPipe,
    IsStepwiseSelectedPipe,
    PositionStylePipe,
    GetClassesForStepwisePipe,
    IsLastOrFirstCellOfStepwisePipe,
    GetStepwisePipe,
    FirstnamesToArrayPipe,
    TruncatePipe,
    DisabledReasonKeyPipe,
    AlertLevelClassPipe,
    FindObsDefByLoincPipe,
    MapChartColorsPipe,
    DateArrayPipe,
    ToDatePipe,
    GetOrgNameFromServiceRefPipe,
    TruncateListPipe,
    HasDrugKnowledgePipe,
    HasDrugInfoLinkPipe,
    FilterByKeyValuePipe,
    GetResultsPractitionnerPipe,
    HasResultsPractitionnerMediaPipe,
    DisplayTextForQuantityPipe,
    TimingDisplay,
    IdentifierPipe,
    DisplayNoSmsCheckbox,
    GetPractitionerNamePipe,
    isMomentStringPipe,
    GetDevicePricePipe,
    IsDefinedPipe,
    IsNotDefinedPipe,
    IsNotCompletedPipe,
    DisabledFeaturesFeaturesPipe,
    FindIdentifierBySystemPipe,
    TeleconsultationLastConnectionPipe,
    IncludesPipe,
    VitalSignRangePipe,
  ],
  imports: [CommonModule],
  exports: [
    CanUpdatePipe,
    DisplayQuantityPipe,
    ComputeScoringPipe,
    FindPreviousQRPipe,
    LoincAndValueMeaningPipe,
    GetTranslationPipeModule,
    ValueObservationPipe,
    QuestionAnswerStrPipe,
    ValueSetChoicesPipe,
    ValueSetChoicePipe,
    QuestionAnswerCodePipe,
    IsQuestionEnabledPipe,
    TranslateAlertNamePipe,
    QRNamePipe,
    QRDatePipe,
    GetEffectiveTimingPipe,
    ActivityDate,
    FirstImagePipe,
    ValidDate,
    EnumToArrayPipeModule,
    IsGoodAnswerPipeModule,
    IsGoodAnswerVer2PipeModule,
    IsBasedOnCareplanPipe,
    GetDataSource,
    RaHasPdfPipe,
    TranslateObservationNameFromObsDefPipe,
    OrgNameFromServiceRefAndMonitLinksPipe,
    SplitPipeModule,
    SafeDatePipeModule,
    JoinPipe,
    GetCurrentObservationPipe,
    IntakesGaugePipe,
    IntakesToolTipPipe,
    HasIntakesDataPipe,
    FrequencyLabelPipe,
    IsActivityADrugPipe,
    TypeOfPipe,
    FindGroupAccessPipe,
    IsAuthorizedPipeModule,
    RiskGaugePipe,
    ActivityLinkedToQuestionnaireModule,
    GetGenderDisplayPipe,
    getIdentityVerificationMethodDisplay,
    GetLatestIdentityFromPatientPipe,
    GetPatientFullNamePipe,
    FilterObsDefinitionsPipe,
    FilterObservationsByLoincPipe,
    GetObsValuesByHoursPipe,
    GetShortnamePipe,
    FindObsDefComponentsByLoincPipe,
    LogPipe,
    IsStepwiseSelectedPipe,
    PositionStylePipe,
    GetClassesForStepwisePipe,
    IsLastOrFirstCellOfStepwisePipe,
    GetStepwisePipe,
    FirstnamesToArrayPipe,
    TruncatePipe,
    DisabledReasonKeyPipe,
    AlertLevelClassPipe,
    FindObsDefByLoincPipe,
    MapChartColorsPipe,
    GetCanDeleteQuestionPipeModule,
    GetQuestionOptionsPipeModule,
    GetCanBeInFormulaPipeModule,
    GetQuestionNumberPipeModule,
    DateArrayPipe,
    ToDatePipe,
    GetOrgNameFromServiceRefPipe,
    GetRangePipeModule,
    RangeSmileyPipeModule,
    GetLabelRangeFromValuePipeModule,
    IsObsCompEnabledPipeModule,
    TruncateListPipe,
    GetValueSetValuePipeModule,
    HasDrugKnowledgePipe,
    HasDrugInfoLinkPipe,
    GetObsComponentPipeModule,
    FilterByKeyValuePipe,
    ExternalUrlPipeModule,
    GetResultsPractitionnerPipe,
    HasResultsPractitionnerMediaPipe,
    DisplayTextForQuantityPipe,
    TimingDisplay,
    IdentifierPipe,
    DisplayNoSmsCheckbox,
    GetPractitionerNamePipe,
    isMomentStringPipe,
    GetDevicePricePipe,
    IsDefinedPipe,
    IsNotDefinedPipe,
    IsNotCompletedPipe,
    DisabledFeaturesFeaturesPipe,
    FindIdentifierBySystemPipe,
    TeleconsultationLastConnectionPipe,
    IncludesPipe,
    VitalSignRangePipe,
  ],
  providers: [IsStepwiseSelectedPipe, GetStepwisePipe], // add pipe to providers to use them inside component.ts e.g. this.myPipe.transform(value)
})
export class PipesModule {}
